import {
  JOB_AZ_CHECK_CATEGORY_OPTIONS,
  JobAzCheckConsultingInfo,
  JobAzCheckConsultingItem,
} from '@agent-ds/shared/interfaces/job-az-check';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ag-job-az-check-consulting-info',
  templateUrl: './job-az-check-consulting-info.component.html',
  styleUrls: ['./job-az-check-consulting-info.component.scss'],
})
export class JobAzCheckConsultingInfoComponent {
  @Input() consultingInfo: JobAzCheckConsultingInfo;
  @Input() showMiddlePermissionResult = false;
  @Input() showDescription = false;
  @Input() editableDescription = false;
  @Output() resultDescriptionChange = new EventEmitter<string>();

  editedDescription = '';

  readonly jobCategoryOptions = JOB_AZ_CHECK_CATEGORY_OPTIONS;

  get consultingItemKeys(): string[] {
    return Object.keys(this.consultingInfo.consultingItems || {});
  }

  getConsultingItem(key: string): JobAzCheckConsultingItem {
    return this.consultingInfo.consultingItems[key];
  }

  getJobCategoryLabel(category: string | null): string {
    const option = this.jobCategoryOptions.find((o) => o.value === category);
    return option ? option.label : '-';
  }

  getMiddlePermissionLabel(flg: 0 | 1 | null): string {
    if (flg === 1) {
      return 'ミドル許容する';
    }
    if (flg === 0) {
      return 'ミドル許容しない';
    }
    return '未定（相談中）';
  }

  onDescriptionInput(value: string): void {
    this.editedDescription = value;
    this.resultDescriptionChange.emit(value);
  }
}
